module.exports = __webpack_public_path__ + "static/media/photo.e09b04a3.png";